import * as React from 'react';
import { FooterLink, FooterJsdIcon, FooterContainer } from './styled';
import { FormattedMessage } from 'react-intl';
import i18n from './messages';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { CTAContainer } from 'view/common/cta-container';

interface Props {
    linkTo: string;
    className?: string;
}

const Footer = ({ linkTo, className }: Props) => {
    return (
        <AnalyticsContext data={{ source: 'footer' }}>
            <CTAContainer />
            <FooterContainer className={className}>
                <FooterLink
                    className="cv-exclude-from-customisation"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={linkTo}
                    actionSubjectId="waclink"
                >
                    <FormattedMessage
                        {...i18n.footer}
                        values={{
                            iconHtml: <FooterJsdIcon />,
                        }}
                    />
                </FooterLink>
            </FooterContainer>
        </AnalyticsContext>
    );
};

export default Footer;
